import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "./Seo";
import { Footer } from "./Footer";

export const Terms = () => (
  <>
    <Seo title="Terms of Use | Nexus Numbers" description="The terms of use for the Nexus Numbers Paystub Generator, including acceptable use and payment terms." canonicalPath="/terms" />
    <main className="max-w-3xl mx-auto px-5 sm:px-8 py-14 min-h-[60vh]">
      <nav className="text-xs text-[#94A3B8] mb-6">
        <Link to="/" className="hover:text-[#1E40AF]">Home</Link> / <span>Terms of Use</span>
      </nav>
      <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight text-[#0F172A]">Terms of Use</h1>
      <p className="text-sm text-[#94A3B8] mt-2">
        Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}
      </p>

      <div className="mt-8 space-y-6 text-[#475569] text-sm leading-relaxed">
        <section>
          <h2 className="font-display text-lg font-semibold text-[#0F172A]">1. Acceptable use</h2>
          <p>Nexus Numbers provides a tool for generating paystubs and earnings statements for your own record-keeping. Every statement you create must reflect actual wages that were genuinely paid. Creating false documents to obtain credit, housing, loans, or benefits is illegal and strictly prohibited.</p>
        </section>
        <section>
          <h2 className="font-display text-lg font-semibold text-[#0F172A]">2. Your responsibility</h2>
          <p>You are solely responsible for the accuracy of the information you enter and for how you use the documents you generate. Nexus Numbers does not verify the data you provide and is not liable for any misuse of generated statements.</p>
        </section>
        <section>
          <h2 className="font-display text-lg font-semibold text-[#0F172A]">3. Payment and revisions</h2>
          <p>Each statement costs a flat $10.00 USD, which includes generation and one free revision. Payments are processed securely by PayPal. The watermark-free PDF is made available only after your payment is confirmed as completed.</p>
        </section>
        <section>
          <h2 className="font-display text-lg font-semibold text-[#0F172A]">4. No professional advice</h2>
          <p>Nexus Numbers is not a payroll provider, accountant, or tax advisor. Tax figures are estimates and should be verified against your own payroll records and applicable law.</p>
        </section>
        <section>
          <h2 className="font-display text-lg font-semibold text-[#0F172A]">5. Refunds</h2>
          <p>Because statements are generated instantly on screen for you to print or download, all sales are final once the PDF has been generated, except where required by law. We do not email statements.</p>
        </section>
        <section>
          <h2 className="font-display text-lg font-semibold text-[#0F172A]">6. Accuracy and honest use</h2>
          <p>I confirm the information I enter is accurate and I will not use this document to misrepresent my income to any landlord, lender, or other party.</p>
        </section>
        <section className="rounded-lg border border-[#D0E2FF] bg-[#F8FAFC] p-4">
          <p className="text-[#1E40AF] font-medium">Statements must reflect actual wages paid. Creating false documents to obtain credit, housing, or benefits is illegal.</p>
        </section>
      </div>
    </main>
    <Footer />
  </>
);
